export default "__VITE_ASSET__lTAZ_wiz__"